import { ButtonV2 } from '@moneyforward/ap-frontend-components';

import { ExportButton } from '@/components/ExportButton/ExportButton';
import { useTranslation } from '@/i18n';
import { FC, memo, useMemo } from 'react';

import {
  ImportExportHistoryLink,
  ImportExportHistorySource,
} from '@/components/ImportExportHistoryLink/ImportExportHistoryLink';
import { ExportCustomTransactionItemOptionsBodyCsvEncoding } from 'ap-openapi';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import styles from './TransactionDetailOptionButtonGroup.module.scss';

export type Props = {
  onAdd: () => void;
  onImport: () => void;
  onExport: (
    csv_encoding: ExportCustomTransactionItemOptionsBodyCsvEncoding
  ) => void;
  isDisabled: boolean;
  isSupportedOffice: boolean;
  isEmptyTable: boolean;
};

const cx = classNames.bind(styles);

export const TransactionDetailOptionButtonGroup: FC<Props> = memo(
  ({
    onAdd,
    onImport,
    onExport,
    isDisabled,
    isSupportedOffice,
    isEmptyTable,
  }: Props) => {
    const { t } = useTranslation();
    const location = useLocation();

    const state = useMemo(() => {
      return { from: location.pathname };
    }, [location.pathname]);

    return (
      <div className={cx(styles['button-group'])}>
        <ImportExportHistoryLink
          source={ImportExportHistorySource.custom_transaction_item_options}
          state={state}
        />
        {isSupportedOffice && (
          <div className={cx(styles.actions)}>
            <ExportButton
              isDisabled={isDisabled || isEmptyTable}
              onExport={onExport}
              size='xs'
            />
            <ButtonV2 isTertiary onClick={onImport} isDisabled={isDisabled}>
              {t('import')}
            </ButtonV2>
            <ButtonV2 onClick={onAdd} isDisabled={isDisabled}>
              {t('add')}
            </ButtonV2>
          </div>
        )}
      </div>
    );
  }
);
TransactionDetailOptionButtonGroup.displayName =
  'TransactionDetailOptionButtonGroup';
